import React, { Component } from 'react'
import { connect } from 'react-redux'
import { IDPhotoComponent } from '../components'
import { saveIDPhoto, resetIDPhoto } from '../actions'
import { updateRequestState, getRequestState } from '../../../shared/actions'
import { isEqual } from 'lodash'

class IDPhoto extends Component {
    constructor(props) {
        super(props)

        this.state = {
            step: 1,
            idPhotoImage: props.idPhoto,
            isCameraOn: false
        }
    }

    componentDidMount = () => {
        this.props.getRequestState()
        if (this.props.history.location.params && this.props.history.location.params.to === 'preview') {
            this.resetIDPhoto()
        } else if (this.state.idPhotoImage) {
            this.setState({ step: 2 })
        }
    }

    handleChange = (key, value) => {
        this.setState({ [key]: value })
    }

    goToScreen = (key, params) => {
        if (this.props.history.location && this.props.history.location.params) {
            this.props.history.push(this.props.history.location.params.to)
        } else {
            this.props.history.push({
                pathname: key,
                params: params
            })
        }
    }

    resetIDPhoto = () => {
        this.props.resetIDPhoto()
        this.setState({ step: 1, idPhotoImage: '' })
    }

    goBack = () => {
        if (this.state.step === 2) {
            this.resetIDPhoto()
        } else {
            this.props.history.replace("idProof")
        }
    }

    captureImage = (image) => {
        this.setState({ step: 2, idPhotoImage: image })
    }

    submit = () => {
        if (!isEqual(this.state.idPhotoImage, this.props.idPhoto)) {
            this.props.updateRequestState({
                upload: ["photo_with_id"],
                state: "photo_with_id_captured",
                data: {
                    photo_with_id: this.state.idPhotoImage,
                },
                nextRoute: 'addressProof'
            })
        } else {
            this.goToScreen('addressProof')
        }
    }

    render() {
        const { language, languageJSON } = this.props
        const { step, idPhotoImage, isCameraOn } = this.state
        return (
            <IDPhotoComponent
                step={step}
                isCameraOn={isCameraOn}
                goBack={this.goBack}
                goToScreen={this.goToScreen}
                language={language}
                languageJSON={languageJSON}
                idPhotoImage={idPhotoImage}
                captureImage={this.captureImage}
                submit={this.submit}
                handleChange={this.handleChange}
            />
        )
    }
}

const mapStateToProps = ({ language: { language, languageJSON }, idPhoto: { idPhoto } }) => ({
    language,
    languageJSON,
    idPhoto
})

const mapDispatchToProps = {
    saveIDPhoto,
    resetIDPhoto,
    updateRequestState,
    getRequestState
}

export default connect(mapStateToProps, mapDispatchToProps)(IDPhoto)

